export default "__VITE_ASSET__DTZERXos__"